import { render, staticRenderFns } from "./AddDocumentDialog.vue?vue&type=template&id=acfa1f7c&scoped=true"
import script from "./AddDocumentDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentDialog.vue?vue&type=style&index=0&id=acfa1f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfa1f7c",
  null
  
)

export default component.exports